var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Menu } from '@pocketlaw/tetris';
import { format, isValid } from 'date-fns';
import { useFormikContext } from 'formik';
import { localeConfig } from 'shared/domains/languages/config';
export function DateField() {
    const { setFieldValue, values, submitForm } = useFormikContext();
    const localeCode = localeConfig.getActiveLocale().code;
    const { value } = values;
    const safeDate = value && isValid(new Date(value)) ? new Date(value) : undefined;
    const handleOnChange = (date) => __awaiter(this, void 0, void 0, function* () {
        const formattedDate = format(date, 'yyyy-MM-dd');
        setFieldValue('value', formattedDate);
        return submitForm();
    });
    return <Menu.Calendar locale={localeCode} value={safeDate} onChange={handleOnChange} closeOnClick={false}/>;
}
